import React from 'react'
import moment from 'moment-mini'
import { genderIdentifier } from 'Utils/genderIdentifier'

const HomeView = ({ subscriberInformation, eligibilityData }) => {
    const isDifferentInsured = eligibilityData.relationship !== "18" || (eligibilityData.patientFirstName !== subscriberInformation.subscriberFirstName)
    return (

        <div className='flex gap-8 p-4 mb-4 rounded-md shadow-sm bg-gray-50 '>
            <div className='flex flex-col gap-1'>
                <div className='flex justify-between align-center'>
                    <span className='mb-6 text-3xl font-semibold'>{subscriberInformation.subscriberFirstName} {subscriberInformation.subscriberLastName}</span>
                </div>
                <div className='flex gap-16'><span className='w-40 font-semibold '>Insurance No:</span>{subscriberInformation.subscriberId}</div>
                <div className='flex gap-16'><span className='w-40 font-semibold'>Gender:</span>{subscriberInformation.subscriberGender}</div>
                <div className='flex gap-16'><span className='w-40 font-semibold'>Group No:</span>{subscriberInformation.subscriberGroupNumber}</div>
                <div className='flex gap-16'><span className='w-40 font-semibold'>Requested Date:</span>{moment(subscriberInformation.eligibilityDate).format('MM/DD/YYYY')}</div>
                <div className='flex gap-16'><span className='w-40 font-semibold'>Result Date:</span>{moment(subscriberInformation.eligibilityResultDate).format('MM/DD/YYYY')}</div>
                <div className='flex gap-16'><span className='w-40 font-semibold'>DOB </span>{moment(subscriberInformation.subscriberDOB).format('MM/DD/YYYY')}</div>
                <div className='flex gap-16'><span className='w-40 font-semibold'>Address </span> <span title={subscriberInformation.subscriberAddress1}>{subscriberInformation.subscriberAddress1}</span></div>
                <div className='flex gap-16'><span className='w-40 font-semibold'>Group # </span>{subscriberInformation.subscriberGroupNumber}</div>
                {isDifferentInsured && (
                    <>
                        <div className='flex gap-16 pt-12 '><span className='w-40 font-semibold '>Patient:</span>{eligibilityData.patientFirstName} {eligibilityData.patientLastName}</div>
                        <div className='flex gap-16'><span className='w-40 font-semibold '>Gender:</span>{genderIdentifier(eligibilityData.patientGender)}</div>
                        <div className='flex gap-16'><span className='w-40 font-semibold '>City:</span>{eligibilityData.patientCity}</div>
                        <div className='flex gap-16'><span className='w-40 font-semibold '>State:</span>{eligibilityData.patientState}</div>
                        <div className='flex gap-16'><span className='w-40 font-semibold '>Zip:</span>{eligibilityData.patientZip}</div>
                    </>
                )}
            </div>

        </div>
    )
}

export default HomeView